import { jsx as e } from "react/jsx-runtime";
const c = t => {
    if (t === "H1") return "h1";
    if (t === "H2") return "h2";
    if (t === "H3") return "h3";
  },
  o = "DescriptionText-module_description-text__XgrGl",
  s = "DescriptionText-module_lead-in__Pj1zd",
  d = "DescriptionText-module_content__Mh3SR",
  n = {
    descriptionText: o,
    leadIn: s,
    content: d
  },
  l = _ref => {
    let {
      children: t,
      headingType: i
    } = _ref;
    const r = c(i) || "div";
    return /* @__PURE__ */e("div", {
      className: n.leadIn,
      children: /* @__PURE__ */e(r, {
        children: t
      })
    });
  },
  x = t => /* @__PURE__ */e("div", {
    className: n.content,
    children: t.children
  }),
  p = t => /* @__PURE__ */e("div", {
    className: n.descriptionText,
    "data-content-name": "description_text",
    children: t.children
  });
export { l as D, x as a, p as b, c as g };